import React, { useState, useEffect } from "react";
import FilterDropdown from "./FilterDropdown";
import useAppStore from "../../store/global";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { ArrowLeftCircle, ArrowRightCircle } from "react-bootstrap-icons";
export default function BreadCrumb({
  text,
  showPosCategories,
  setPageIndex,
  startDate,
  setStartDate,
  showDatePicker = false,
  setScrappers_type,
  scrappers_type,
  showHomeFilter = false,
  showSimplifiedViewLink = false,
  setSearchTerm = () => {},
  children,
  showFilterDropdown=true,
  showCalendricViewLink = false,
  onCalendricViewToggle = () => {},
  isCalendricViewActive = false
}) {
  const {
    isChanged,
    setIsChanged,
    setPageNum
  } = useAppStore();

  const path = useParams();
  const navigate = useNavigate();
  const pathname = useParams();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setSearchTerm(inputValue);
    }, 500);

    return () => clearTimeout(debounceTimeout);
  }, [inputValue]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center gap-2 p-3 mx-2 my-4 rounded rounded-lg bg-body-secondary">
        <span
          className="text-muted"
          style={{
            fontSize: "17px"
          }}
        >
          {text}
        </span>
        <div className="d-flex flex-wrap align-items-center gap-2 ms-auto py-0 mw-100">
          {showFilterDropdown&&Object?.keys(path)?.length !== 0 && (
            <FilterDropdown
              showPosCategories={showPosCategories}
              setPageIndex={setPageIndex}
            />
          )}
          {showHomeFilter && (
            <>
              <input
                className="form-control"
                value={inputValue}
                style={{
                  width: "290px",
                  maxWidth: "100%",
                  height: "40px",
                  borderRadius: "5px"
                }}
                placeholder="Search Restaurant Name..."
                onChange={handleChange}
              />

            </>
          )}
          {children}

          {window.location.pathname == "/" && (
            <button
              className="btn btn-sm btn-warning mx-2"
              onClick={() => {
                navigate("/manage-cb-categories");
              }}
            >
              Manage CB Categories
            </button>
          )}
          {window.location.pathname == "/" && (
            <button
              className="btn btn-sm btn-primary mx-2"
              onClick={() => {
                navigate("/master-report-status");
              }}
            >
              Master Report Staus
            </button>
          )}
          {showSimplifiedViewLink && (
            <button
              className="btn btn-sm btn-success mx-2"
              onClick={() => {
                navigate("/crunch-analytics");
              }}
            >
              Simplified View
            </button>
          )}
          {showCalendricViewLink && (
             <button
              className="btn btn-sm btn-success mx-2"
              onClick={onCalendricViewToggle}
            >
              Calendric View
            </button>
          )}
          {showDatePicker && (
            <span className="d-flex align-items-center py-0">
              <ArrowLeftCircle
                className="mx-1 py-0"
                style={{
                  cursor: "pointer"
                }}
                onClick={() => {
                  let date = new Date(startDate);
                  date.setDate(date.getDate() - 1);
                  setStartDate(date);
                }}
              />
              <DatePicker
                placeholderText="Select Date"
                showIcon
                className="w-100"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                icon="fa fa-calendar"
              />
              <ArrowRightCircle
                className="mx-1 py-0"
                style={{
                  cursor: "pointer"
                }}
                onClick={() => {
                  let date = new Date(startDate);
                  date.setDate(date.getDate() + 1);
                  setStartDate(date);
                }}
              />
            </span>
          )}

        </div>
      </div>
    </>
  );
}
